<template>
    <div>

        <div class="alert alert-info text-center rounded-0 mb-0" v-if="!isFirstLogin">
            <span>
                Primeiro acesso? veja nosso passo a passo!
            </span>
            <a href="/tutorial" class="btn btn-sm ml-2 btn-primary">Acessar tutorial</a>

        </div>
        <div class="mb-3 bg-white shadow-sm">
            <div class="container py-2 py-sm-4" role="alert" v-if="teacher">
                <div class="d-none d-sm-flex justify-content-start align-items-center">
                    <div class="border-end pl-1 pr-4">
                        <button type="button" class="close text-primary" v-b-tooltip.hover title="Código usado para outros professores se cadastrarem na sua organização">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                            </svg>
                        </button>
                        <b class="d-block">
                            {{ code }}
                        </b>
                        <small>
                            Código da Escola
                        </small>
                    </div>
                    <div class="pl-4 pr-1 fs-6 text-dark">
                        Olá, <b>{{ teacherJson.name }}</b>, seja bem-vindo(a) à plataforma  <b>{{ nameSchool }}</b>.
                    </div>
                </div>

                <div class="d-block d-sm-none">
                    <div class="border-bottom p-2">
                        <button type="button" class="close text-primary" v-b-tooltip.hover title="Código usado para outros professores se cadastrarem na sua organização">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                            </svg>
                        </button>
                        <b class="d-block">
                            {{ code }}
                        </b>
                        <small>
                            Código da Escola
                        </small>
                    </div>
                    <div class="p-2">
                        Olá <b>{{ teacherJson.name }}</b> seja bem-vindo(a) à plataforma  <b>{{ nameSchool }}</b>.
                    </div>
                </div>
            </div>
        </div>
        <div class="container mt-2 lg:mt-4 sm-2">
            <div class="row" v-if="isOwner && limitStudents" v-show="students/limitStudents*100 >80">
                <div class="mb-2">
                    <b-alert variant="danger">
                        Quantidade de alunos proximo do limite verifique sua assinatura
                    </b-alert>
                </div>
            </div>
            <div class="row">
                
                <div class="col">
                    <div class="row row-cols-1 row-cols-md-2 row-cols-xl-4">
                        <div class="col-lg-6 mb-4" v-if="canTurmas">
                            <div class="card">
                                <div class="card-body h-100 my-2">
                                    <button type="button" class="close text-primary" v-b-tooltip.hover title="Quantidade de turmas ativas nessa organização">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                    </button>
                                    <div class="d-flex gap-3 align-items-center" style="">
                                        <div class="rounded-circle p-2" style="background-color: #a9dfffb0;">
                                            <svg style=" color: #007bc2;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.627 48.627 0 0112 20.904a48.627 48.627 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.57 50.57 0 00-2.658-.813A59.905 59.905 0 0112 3.493a59.902 59.902 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.697 50.697 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5" />
                                            </svg>
                                        </div>
                                        <div class="lh-sm">
                                            <div class="fs-4"><b>{{ groups }}</b></div>
                                            <div class="">Turmas</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4" v-if="canAlunos">
                            <div class="card">
                                <div class="card-body my-2">
                                    <button type="button" class="close text-primary" v-b-tooltip.hover title="Quantidade de alunos ativos na organização">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                    </button>
                                    <div class="d-flex gap-3 align-items-center" style="">
                                        <div class="rounded-circle p-2" style="background-color: #ffeba9b0;"  >
                                            <svg style=" color: #c26e00;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                                            </svg>
                                        </div>
                                        <div class="lh-sm">
                                            <div class="fs-4"><b>{{ students }}</b><b v-if="isOwner">/{{ limitStudents}}</b></div>
                                            <div>Alunos</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4" v-if="canAlunos">
                            <div class="card">
                                <div class="card-body h-100 my-2">
                                    <button type="button" class="close text-primary" v-b-tooltip.hover title="Quantidade de alunos bloqueados na organização">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                    </button>
                                    <div class="d-flex gap-3 align-items-center" style="">
                                        <div class="rounded-circle p-2" style="background-color: #ffa9a9b0;">
                                            <svg style=" color: #c20000;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem" width="2rem">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
                                            </svg>
                                        </div>

                                        <div class="lh-sm">
                                            <div class="fs-4"><b>{{ studentsBlocked }}</b></div>
                                            <div>Alunos bloqueados</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 mb-4" v-if="canTemas">
                            <div class="card">
                                <div class="card-body my-2">
                                    <button type="button" class="close text-primary" v-b-tooltip.hover title="Quantidade de temas disponíveis na organização">
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                                        </svg>
                                    </button>
                                    <div class="d-flex gap-3 align-items-center" style="">
                                        <div class="rounded-circle p-2"  style="background-color: #a9ffd0b0;">
                                            <svg style=" color: #00c288;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="2rem">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                                            </svg>
                                        </div>
                                        <div class="lh-sm">
                                            <div class="fs-4"><b>{{ themes }}</b></div>
                                            <div>Temas</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex flex-column flex-lg-row">
                    </div>
                </div>
            </div>
            <div class="row d-flex flex-column flex-lg-row">
                <div class="col-lg-6 mb-4" v-if="canAlunos">
                    <div class="card">
                        <div class="card-header font-weight-bold">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="font-weight-bold">
                                    Alunos ({{ students }} no total)
                                </div>
                                <div>
                                    <a href="/teacher/students/all" class="text-black" v-b-tooltip.hover title="Ver Alunos">
                                        <svg height="1.25rem" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div id="student-chart" class="card-body">
                            <chart-students :chartData="studentsData" :students="students" ></chart-students>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 mb-4">
                    <div class="card">
                        <div class="card-header">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="font-weight-bold">
                                    Redações ({{ parseInt(essaysInProgress) + parseInt(essaysOkay) + parseInt(essaysWait) }} no total)
                                </div>
                                <div>
                                    <a :href="routeEssays" class="text-black" v-b-tooltip.hover title="Ver Redações">
                                        <svg height="1.25rem" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                                            <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="card-body">
                            <chart-essays :chartData="essaysData"></chart-essays>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-if="canRelatoriosProfessor">
                <div class="col mb-4">
                    <div class="card">
                        <div class="card-header d-flex justify-content-between">
                            <div class="font-weight-bold">
                                Desempenho dos professores nos últimos 30 dias
                            </div>
                            <div role="button" class="rounded-circle" @click="showTeacherTable = !showTeacherTable">
                                <svg v-if="showTeacherTable" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem" v-b-tooltip.hover title="Ocultar Valores">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" height="1.25rem" v-b-tooltip.hover title="Mostrar Valores">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88" />
                                </svg>
                            </div>
                        </div>
                        <div class="card-body">
                            <b-overlay :show="loading" rounded="sm">
                                <table-teacher :show-teacher-table="showTeacherTable" :table="teachersData"></table-teacher>
                            </b-overlay>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ChartStudents from './ChartStudents.vue';
import tableTeacher from './Table.vue';
import ChartEssays from './ChartEssays.vue';
import SideBarTour from '../../../components/SideBarTour.vue';

export default {
    components:{
        SideBarTour,
        ChartEssays,
        ChartStudents,
        tableTeacher
    },
    props: ['nameSchool','endsAt','stripeStatus','trialEndsAt', 'isOwner','groups','students','teacher','limitStudents', 'studentsBlocked', 'themes', 'code', 'essaysWait', 'essaysOkay', 'essaysInProgress', 'canAlunos', 'canTurmas','canTemas','canRelatoriosProfessor', 'routeEssays'],
    data(){
        return {
            showTeacherTable : false,
            loading: false,
            studentsData: [
                ['Alunos','Quantidade'],
                ['Ativos', parseInt(this.students)-parseInt(this.studentsBlocked)],
                ['Bloqueados',parseInt(this.studentsBlocked)]
            ],
            essaysData: [
                ['Redações', 'Quantidade', { role: 'style'}, {role:'annotation'} ],
                ['Corrigidas',parseInt(this.essaysOkay), '#3aa568', parseInt(this.essaysOkay)],
                ['Aguardando', parseInt(this.essaysWait), '#d6504e', parseInt(this.essaysWait)],
                ['Em correção', parseInt(this.essaysInProgress),'#1C5593', parseInt(this.essaysInProgress)],
            ],
            teachersData: [],
        }
    },
    created(){
        this.load();
    },
    computed: {
        teacherJson(){
            return JSON.parse(this.teacher)
        },
        isFirstLogin(){
            return window.localStorage.getItem('first-login')
        }
    },
    methods: {
        load() {
            const today = new Date();
            const daysAgo = this.$moment(today).subtract(30, 'days');

            this.loading = true;
            axios.get('/teacher/reports-teachers/essays', {
                params: {
                    start_date: this.$moment(daysAgo).format('YYYY-MM-DD'),
                    end_date: this.$moment(today).format('YYYY-MM-DD'),
                }
            })
                .then(async (result) => {
                    const response = result.data.data;

                    this.teachersData = response.teachers;

                })
                .finally(() => this.loading = false)
        },
        daysForEnd(days) {
            const today = new Date()
            if(this.endsAt){
                const endsAtDate = new Date(this.endsAt)
                const daysToEnd = (endsAtDate-today)/ (1000 * 60 * 60 * 24)


                if(days >= daysToEnd){
                    return daysToEnd
                }
                return false


            }
            const trialDate = new Date(this.trialEndsAt)
            const daysToEnd =(trialDate-today)/ (1000 * 60 * 60 * 24)

            if(days >= daysToEnd){
                return daysToEnd
            }
            return false

        }
    }
}
</script>

<style scoped>
    #student-chart{
        position: relative;
    }
    .divider {
        border-right: 1px solid #dee2e6;
    }
</style>
